import React from 'react'
import log from 'lib/log'
import { findInterestingPeople } from 'actions/users'
import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
const component = universal(props => import('./HomePeoplePage.js'))
import HomePeopleExtraNav from './HomePeopleExtraNav'
import { get_query } from 'lib/search_util'

class AsyncHomePeoplePage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    let { navigation: { stack } } = getState()
    let search = get_query(stack)
    try {
      await findInterestingPeople({ filter: search })(dispatch, getState, opts)
    } catch (e) {
      log.error(e)
    }
  }
  getExtraSecondaryNavigation() {
    return <HomePeopleExtraNav key={Date.now() + '_'} />
  }
}

export default new AsyncHomePeoplePage()
